import {useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from './keys'
import {getFeaturedCreators} from '../services/auth.http'

export const useGetFeaturedCreators = ({
    responseType = 'small',
    enabled = true
}: {
    responseType?: 'extended' | 'small'
    enabled?: boolean
}) => {
    const query = useQuery({
        queryKey: [QUERY_KEYS.featured_creators, responseType],
        queryFn: () => getFeaturedCreators(responseType),
        enabled
    })
    return {...query, data: query.data ?? []}
}
